import { render, staticRenderFns } from "./QuestActivity.vue?vue&type=template&id=bf5b4c5e&scoped=true&"
import script from "./QuestActivity.vue?vue&type=script&lang=js&"
export * from "./QuestActivity.vue?vue&type=script&lang=js&"
import style0 from "./QuestActivity.vue?vue&type=style&index=0&id=bf5b4c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5b4c5e",
  null
  
)

export default component.exports